import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneSelect } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'
import { Col } from 'antd'
import { useSelector } from '@/store/index'
import NumberFormatInput from '@/bizComponent/NumberFormatInput'
import type { OptionType } from './SchemaForm'

interface IProps {
  defaultValue?: string
  required?: boolean
  options: OptionType[]
  channelCode?: string
}
const Taxation: FC<IProps> = (props) => {
  const { defaultValue, required = false, options } = props
  const { t } = useTranslation()

  const njeCityName = useSelector((store) => store.configSlice?.njeCityName)
  const departureCity = useSelector((store) => store.newServiceProvider?.props?.addressVO?.departure_city)
  const channelCode = useSelector((store) => store.newServiceProvider?.provider?.companyCode)

  return (
    <>
      <Col span={6}>
        <FormItem name="provider_taxationCurrencyCode" label={t('provider.form.tax.currency')} initialValue={options?.[0].value}>
          <OneSelect>
            {options.map(({ value }) => {
              return <OneSelect.Option value={value}>{value}</OneSelect.Option>
            })}
          </OneSelect>
        </FormItem>
      </Col>
      <Col span={6}>
        <FormItem
          name="provider_taxation"
          initialValue={defaultValue}
          label={t('provider.form.tax.price')}
          required={required}
          rules={RULES.provider_taxation({
            isRequired: required,
            channelCode,
            departureCity,
            requireName: njeCityName,
          })}
        >
          <NumberFormatInput placeholder={t('common.input.placeholder')} />
        </FormItem>
      </Col>
    </>
  )
}

export default Taxation
